<template>
    <div>
        <div class="contents">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="breadcrumb-main user-member justify-content-sm-between ">
                            <div class=" d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                                <div
                                    class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                    <h4 class="text-capitalize fw-500 breadcrumb-title">Pengaturan Webhook</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 mb-4" v-for="(d, idx) in device" :key="d.id">
                        <div class="card shadow-sm">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h5 class="mb-0">{{ d.name }}</h5>
                                <span :class="['badge', d.status === 'connected' ? 'badge-success' : 'badge-danger']">
                                    {{ d.status === 'connected' ? 'Terkoneksi' : 'Tidak Terkoneksi' }}
                                </span>
                            </div>
                            <div class="card-body">

                                <!-- Webhook 1 -->
                                <div class="mb-3">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="mb-0">Webhook</h6>
                                        <button class="btn btn-sm btn-outline-primary" @click="addWebhook(idx)">+</button>
                                    </div>
                                    <div v-for="(link, index) in d.webhook" :key="index" class="input-group mb-2">
                                        <input type="text" v-model="d.webhook[index]" class="form-control"
                                            placeholder="https://example.com">
                                        <button class="btn btn-outline-danger"
                                            @click="deleteWebhook(idx, index)">Hapus</button>
                                    </div>
                                    <!-- <button class="btn btn-outline-success btn-block" @click="saveWebhook(idx)">Simpan</button> -->
                                </div>

                                <hr>

                                <!-- Webhook 2 -->
                                <div class="mb-3">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="mb-0">Webhook 2 (Device Data)</h6>
                                        <button class="btn btn-sm btn-outline-primary" @click="addWebhook2(idx)">+</button>
                                    </div>
                                    <div v-for="(link, index) in d.webhook2" :key="index" class="input-group mb-2">
                                        <input type="text" v-model="d.webhook2[index]" class="form-control"
                                            placeholder="https://example.com">
                                        <button class="btn btn-outline-danger"
                                            @click="deleteWebhook2(idx, index)">Hapus</button>
                                    </div>
                                    <!-- <button class="btn btn-outline-success btn-block" @click="saveWebhook2(idx)">Simpan</button> -->
                                </div>

                                <!-- Webhook 3: Image -->
                                <div class="mb-3" v-if="d.webhook_media_quota > 0">
                                    <hr>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="mb-0">Webhook 3 (Media)</h6>
                                        <button class="btn btn-sm btn-outline-primary" @click="addWebhook3(idx)">+</button>
                                    </div>

                                    <div v-for="(link, index) in d.webhook3" :key="index" class="input-group mb-2">
                                        <input type="text" v-model="d.webhook3[index]" class="form-control"
                                            placeholder="https://example.com">
                                        <button class="btn btn-outline-danger"
                                            @click="deleteWebhook3(idx, index)">Hapus</button>
                                    </div>
                                    <!-- <button class="btn btn-outline-success btn-block" @click="saveWebhook3(idx)">Simpan</button> -->
                                </div>
                                <!-- Webhook Group Message -->
                                <div class="mb-3" v-if="webhook_group">
                                    <hr>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="mb-0">Webhook Group</h6>
                                        <button class="btn btn-sm btn-outline-primary" @click="addWebhookGroup(idx)">+</button>
                                    </div>

                                    <div v-for="(link, index) in d.webhook_group" :key="index" class="input-group mb-2">
                                        <input type="text" v-model="d.webhook_group[index]" class="form-control"
                                        placeholder="https://example.com">
                                        <button class="btn btn-outline-danger" @click="deleteWebhookGroup(idx, index)">Hapus</button>
                                    </div>

                                    <!-- <button class="btn btn-outline-success btn-block" @click="saveWebhookGroup(idx)">Simpan</button> -->
                                </div>
                                <!-- Webhook Premium -->
                                <div class="mb-3" v-if="webhook_premium">
                                    <hr>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="mb-0">Webhook Premium</h6>
                                        <button class="btn btn-sm btn-outline-primary" @click="addWebhookPremium(idx)">+</button>
                                    </div>

                                    <div v-for="(link, index) in d.webhook_premium" :key="index" class="input-group mb-2">
                                        <input type="text" v-model="d.webhook_premium[index]" class="form-control"
                                        placeholder="https://example.com">
                                        <button class="btn btn-outline-danger" @click="deleteWebhookPremium(idx, index)">Hapus</button>
                                    </div>

                                    <!-- <button class="btn btn-outline-success btn-block" @click="saveWebhookPremium(idx)">Simpan</button> -->
                                </div>
                                <div class="mb-3">
                                    <hr>
                                    <button class="btn btn-success btn-block" @click="saveAll(idx)">Simpan Semua</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                device: {},
                webhook_group: this.$store.state.auth?.package?.webhook_group == 1 ? true : false,
                webhook_premium: this.$store.state.auth?.package?.webhook_premium == 1 ? true : false
            };
        },
        mounted() {
            this.getDevice()
        },
        methods: {
            async getDevice() {
                let res = await this.$store.dispatch("device_list_all");
                this.device = res.data.data.devices

                for (let i = 0; i < this.device.length; i++) {
                    this.device[i].webhook = this.device[i].webhook ? JSON.parse(this.device[i].webhook) : []
                    this.device[i].webhook2 = this.device[i].webhook2 ? JSON.parse(this.device[i].webhook2) : []
                    this.device[i].webhook3 = this.device[i].webhook3 ? JSON.parse(this.device[i].webhook3) : []
                    this.device[i].webhook_group = this.device[i].webhook_group ? JSON.parse(this.device[i]
                        .webhook_group) : []
                    this.device[i].webhook_premium = this.device[i].webhook_premium ? JSON.parse(this.device[i].webhook_premium) : []
                }
            },
            addWebhook(index) {
                this.device[index].webhook.push("")
            },
            deleteWebhook(idx, index) {
                this.device[idx].webhook.splice(index, 1)
            },
            async saveWebhook(index) {
                try {
                    let response = await this.$store.dispatch('device_update_webhook', {
                        id: this.device[index].id,
                        webhook: this.device[index].webhook
                    })
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            addWebhook2(index) {
                this.device[index].webhook2.push("")
                this.$forceUpdate()
            },
            deleteWebhook2(idx, index) {
                this.device[idx].webhook2.splice(index, 1)
            },
            async saveWebhook2(index) {
                try {
                    let response = await this.$store.dispatch('device_update_webhook2', {
                        id: this.device[index].id,
                        webhook: this.device[index].webhook2
                    })
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            addWebhook3(index) {
                this.device[index].webhook3.push("")
            },
            deleteWebhook3(idx, index) {
                this.device[idx].webhook3.splice(index, 1)
            },
            async saveWebhook3(index) {
                try {
                    let response = await this.$store.dispatch('device_update_webhook3', {
                        id: this.device[index].id,
                        webhook: this.device[index].webhook3
                    })
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            addWebhookGroup(index) {
                this.device[index].webhook_group.push("")
            },
            deleteWebhookGroup(idx, index) {
                this.device[idx].webhook_group.splice(index, 1)
            },
            async saveWebhookGroup(index) {
                try {
                    let response = await this.$store.dispatch('device_update_webhook_group', {
                        id: this.device[index].id,
                        webhook: this.device[index].webhook_group
                    })
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            addWebhookPremium(index) {
                this.device[index].webhook_premium.push("")
            },
            deleteWebhookPremium(idx, index) {
                this.device[idx].webhook_premium.splice(index, 1)
            },
            async saveWebhookPremium(index) {
                try {
                    let response = await this.$store.dispatch('device_update_webhook_premium', {
                        id: this.device[index].id,
                        webhook: this.device[index].webhook_premium
                    })
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            async saveAll(index) {
                try {
                    let response = await this.$store.dispatch('device_update_webhook_all', {
                        id: this.device[index].id,
                        webhook: this.device[index].webhook,
                        webhook2: this.device[index].webhook2,
                        webhook3: this.device[index].webhook3,
                        webhook_group: this.device[index].webhook_group,
                        webhook_premium: this.device[index].webhook_premium
                    })
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            }
        },
    };
</script>